module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-white@3x-0941523d.svg";